export const XS_UPPER = 576;
export const SM_UPPER = 768;
export const MD_UPPER = 992;
export const LG_UPPER = 1200;
